import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { firstValueFrom } from 'rxjs';
import { Logger } from '../../../infrastructure/logging/logger';
import { AdminPortalAPIHttpClient } from '../../../infrastructure/http/v2/AdminPortalAPIHttpClient';
import { isStringEmptyOrNull } from '../../../utilities/StringUtility';
import { BadGuest } from '../models/BadGuest';

@Injectable({
  providedIn: 'root'
})
export class BadGuestsService {

  constructor(
    private adminPortalHttpClient: AdminPortalAPIHttpClient,
    private logService: Logger,
    private snackbar: MatSnackBar
  ) { }

  async getBadGuests(): Promise<BadGuest[]> {
    try {
      const response: any = await firstValueFrom(this.adminPortalHttpClient.get(`/bad-guests/query`));
      return Promise.resolve(response.data);
    } catch (e) {
      this.logService.handleError(e, 'An error occurred while retrieving Bad Guests', 'An error occurred while retrieving Bad Guests');
      return Promise.reject(`Error while retrieving bad guests`);
    }
  }

  async createBadGuest(payload: any): Promise<BadGuest> {
    try {
      const response: any = await firstValueFrom(this.adminPortalHttpClient.post(`/bad-guests`, payload));
      if (!response) {
        return Promise.reject(`Create bad guest response null`);
      } else {
        if (response.err != null && !isStringEmptyOrNull(response.err.msg)) {
          this.displaySnackbar(response.err.msg);
        } else {
          this.displaySnackbar(response.err, 'Create');
        }
      }

      return response.data;
    } catch (e) {
      return Promise.reject(`Error while creating bad guest: ${e}`);
    }
  }

  async updateBadGuest(badGuestId: number, badGuest: any): Promise<BadGuest> {
    try {
      const response: any = await firstValueFrom(this.adminPortalHttpClient.put(`/bad-guests/${badGuestId}`, badGuest));
      if (!response) {
        return Promise.reject(`Update bad guest response null ${badGuestId}`);
      } else {
        if (response.err != null && !isStringEmptyOrNull(response.err.msg)) {
          this.displaySnackbar(response.err.msg);
        } else {
          this.displaySnackbar(response.err, 'Update');
        }
      }

      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject(`Error while updating bad guest ${badGuestId}: ${e}`);
    }
  }

  async deleteBadGuest(badGuestId: number): Promise<any> {
    try {
      const response: any = await firstValueFrom(this.adminPortalHttpClient.delete(`/bad-guests/delete/${badGuestId}`));
      if (!response) {
        return Promise.reject(`Delete bad guest response null`);
      } else {
        if (response.err != null && !isStringEmptyOrNull(response.err.msg)) {
          this.displaySnackbar(response.err.msg);
        } else {
          this.displaySnackbar(response.err, 'Delete');
        }
      }

      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject(`Error while deleting bad guest: ${e}`);
    }
  }


  displaySnackbar(errorMessage: string, method?: string) {
    if (isStringEmptyOrNull(errorMessage)) {
      this.displaySuccessSnackbar(method);
    } else {
      this.displayErrorSnackbar(errorMessage);
    }
  }
    
  displaySuccessSnackbar(method?: string) {
    this.snackbar.open(`${method} Successful`, 'OK', { duration: 4000 });
  }

  displayErrorSnackbar(errorMessage: string) {
    this.snackbar.open(`Error Saving Bad Guest: ${errorMessage}`, 'OK', { duration: 4000 });
  }
}